<div class="card">
    <div class="title-container">
        <img [src]="icon"/>
        <h5>{{title}}</h5>
    </div>
    <p>{{description}}</p>
</div>